export default "__VITE_ASSET__CWeAFJgy__"